import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import { npsStatus } from '../api';

function useStatus() {
  const [state, setState] = useState<{
    loading: boolean;
    error: boolean;
  }>({ loading: false, error: false });

  const { enqueueSnackbar } = useSnackbar();

  async function handleSetStatus() {
    try {
      setState({ loading: true, error: false });

      const response = await npsStatus();

      enqueueSnackbar(response, { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    } catch (error) {
      const message = (error as AxiosError).response?.data?.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    } finally {
      setState({ loading: false, error: false });
    }
  }

  return { handleSetStatus, statusState: state };
}

export default useStatus;
